export default __webpack_public_path__ + "static/media/custom-product.56f52c00.jpeg";